import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useTranslation } from 'react-i18next'

import closeModal from '../../utils/closeModal'
import DefaultButton from './default-button'
import Modal from './modal'

const ConfirmDownload = ({ link }: { link: string }) => {
  const modal = useModal()
  const { t } = useTranslation('common')

  const handleDownload = () => {
    window.open(link, '_blank')
    closeModal(modal)
  }

  return (
    <Modal id="confirm-download" zIndex={204}>
      <p className="text-[#888] dark:text-[#e6e6e6] text-lg text-center font-normal mb-[5px] xl:text-xl">
        {t('sure-you-want-to-download')}
      </p>
      <div className="flx-ctr gap-[15px] mt-[35px]">
        <DefaultButton size="large" onClick={() => closeModal(modal)}>
          {t('cancel')}
        </DefaultButton>
        <DefaultButton variant="blue" size="large" onClick={handleDownload}>
          {t('confirm')}
        </DefaultButton>
      </div>
    </Modal>
  )
}

export default NiceModal.create(ConfirmDownload)
